import React, { useEffect, useState, useCallback, useRef, useMemo } from 'react';
import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { List, ListItem, ListItemButton, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import tokens from '../../../../utils/Tokens.json';
import Inex from '../../../../assets/updated/buySell/INEX.svg';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { getCoinPriceByName } from '../../../../services/api';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import {
  getEmailFromStorage,
  isTokenVisibleOnBuySell,
  normalizeEmail,
} from '../../../../utils/tokenVisibility';
import smbannerlight from '../../../../assets/updated/buySell/Early fall light.svg';
import smbannerDark from '../../../../assets/updated/buySell/Early fall Dark.svg';

import smbannerDaCrazyLightMode from '../../../../assets/updated/buySell/smBannerDaCrazyLightMode.png';
import smbannerDaCrazyDarkMode from '../../../../assets/updated/buySell/smBannerDaCrazyDarkMode.png';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '22px 6px 6px 6px',
    margin: '20px 0px',
    borderRadius: '8px',
    position: 'relative',
    border: `1px solid ${
      theme.palette.mode === 'light' ? '#E0E3E7' : '#2D3843'
    }`,
    fontSize: 16,
    width: '100%',
    transition: theme.transitions.create(['border-color', 'background-color']),
    '&:focus': {
      borderColor: `${theme.palette.primary.main} !important`,
    },
    '&:hover': {
      borderColor: `${theme.palette.primary.main} !important`,
    },
  },
  label: {
    fontSize: '18px !important',
    fontFamily: 'poppins !important',
    fontWeight: '600 !important',
  },
  formControl: {
    width: '100%',
  },
  textField: {
    width: '100%',
    color: `${theme.palette.text.primary} !important`,
    '& .MuiOutlinedInput-root': {
      color: `${theme.palette.text.primary} !important`,
      fontSize: '24px !important',
      fontWeight: '600 !important',
      '& fieldset': {
        border: 'none',
        color: `${theme.palette.text.primary} !important`,
      },
    },
  },
  searchField: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      height: '42px',
      border: `1px solid ${
        theme.palette.mode === 'light' ? '#E0E3E7' : '#2D3843'
      } !important`,
      fontSize: 16,
      borderRadius: '12px',
      color: `${theme.palette.text.primary} !important`,
      width: '100%',
      transition: theme.transitions.create([
        'border-color',
        'background-color',
      ]),
      '&:focus': {
        borderColor: `${theme.palette.primary.main} !important`,
      },
      '&:hover': {
        borderColor: `${theme.palette.primary.main} !important`,
      },
      '& fieldset': {
        border: 'none',
      },
    },
  },
  dropDownIconContainer: {
    display: 'flex',
    gap: '5px',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      width: '20px',
      height: '20px',
      // borderRadius: '50%',
    },
    '& p': {
      fontSize: '16px',
      marginLeft: '5px',
      color: `${theme.palette.text.primary} !important`,
    },
  },
  availableContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    paddingLeft: '17px', // Ensure it aligns with input
  },
  availableText: {
    color: theme.palette.text.secondary,
    fontSize: '14px', // Slightly smaller for "Available" text
    lineHeight: '1.5', // Adjust for better readability
  },
  dropDownContainer: {
    zIndex: '111',

    background: theme.palette.mode === 'dark' ? '#1E2329' : '#ffff',
    boxShadow:
      'rgba(0, 0, 0, 0.08) 0px 1px 10px 0px, rgba(0, 0, 0, 0.05) 0px 0px 3px 0px',
    marginTop: '-10px',
    position: 'absolute',
    width: '100%',
    paddingBottom: '10px',
    paddingTop: '10px',
    overflow: 'hidden',
    borderRadius: '16px',
  },
  dropDownContent: {
    height: '100%',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '7px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor:
        theme.palette.mode === 'dark'
          ? '#5f6673 !important'
          : '#b7bdc6 !important',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-track': {
      display: 'none !important', // Hide the scrollbar track
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor:
        theme.palette.mode === 'dark'
          ? '#484f59 !important' // Darker color for dark mode
          : '#a0a6af !important', // Darker color for light mode
    },
  },
  listContainer: {
    '&.MuiListItemButton-root': {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      padding: 10,
    },
  },
  logoContainer: {
    display: 'flex',
    gap: '10px',
    '& img': {
      width: '20px',
      height: '20px',
    },
    '& p': {
      fontSize: '14px',
      fontWeight: '500',
      color: `${theme.palette.text.primary} !important`,
    },
  },
  message: {
    marginTop: '10px',
    color: '#11BE6A',
  },
}));
const getImage = (image) => {
  console.log('my image', image);
  try {
    return require(`../../../../assets/token-icons/${image}.png`).default;
  } catch (error) {
    return Inex; // Fallback image if specific token icon is not found
  }
};
const CustomTextField = ({
  placeholder,
  label,
  type,
  onSelectToken,
  onAmountChange,
  onReceiveAmountChange,
  onPriceChange,
  amount,
  receiveAmount,
  tokenType,
  disableDropdown,
  fixedToken,
  loggedIn,
  defaultReceiveToken,
  balance,
  setTokenPriceLoading,
  fromToken, // For convert: pass fromToken to filter "to" tokens
  btcYAllowedEmails,
}) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isWhitelisted, setIsWhitelisted] = useState(() => {
    const stored = localStorage.getItem('isWhitelisted');
    // Handle case-insensitive check
    const isWhitelistedValue = stored !== null && String(stored).toLowerCase() === 'true';
    console.log('🔍 CustomTextField - Initial isWhitelisted state:', isWhitelistedValue, 'from localStorage:', stored);
    return isWhitelistedValue;
  });
  
  // Listen for localStorage changes and update whitelisted status
  useEffect(() => {
    const checkWhitelistedStatus = () => {
      const stored = localStorage.getItem('isWhitelisted');
      // Handle case-insensitive check (could be 'True', 'False', 'true', 'false', etc.)
      const whitelisted = stored !== null && String(stored).toLowerCase() === 'true';
      console.log('🔍 CustomTextField - Checking whitelisted status:', whitelisted, 'from localStorage:', stored);
      setIsWhitelisted(whitelisted);
    };
    
    // Check on mount
    checkWhitelistedStatus();
    
    // Listen for storage events (when localStorage changes in other tabs/windows)
    const handleStorageChange = (e) => {
      if (e.key === 'isWhitelisted') {
        checkWhitelistedStatus();
      }
    };
    
    // Listen for custom event when whitelisted status is updated
    const handleWhitelistedUpdate = (e) => {
      console.log('🔍 CustomTextField - Received whitelistedStatusUpdated event:', e.detail);
      checkWhitelistedStatus();
      // Force refresh of token list when whitelisted status changes
      setWhitelistRefreshKey(prev => prev + 1);
    };
    
    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('whitelistedStatusUpdated', handleWhitelistedUpdate);
    
    // Also check periodically in case localStorage is updated in the same tab
    const interval = setInterval(() => {
      const previousValue = localStorage.getItem('isWhitelisted');
      checkWhitelistedStatus();
      const newValue = localStorage.getItem('isWhitelisted');
      // If whitelisted status changed, force refresh
      if (previousValue !== newValue) {
        console.log('🔄 Whitelisted status changed in interval check. Forcing refresh.');
        setWhitelistRefreshKey(prev => prev + 1);
      }
    }, 500); // Check every 500ms for faster updates
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('whitelistedStatusUpdated', handleWhitelistedUpdate);
      clearInterval(interval);
    };
  }, []);

  // Close and refresh dropdown when fromToken changes (for "to" field)
  useEffect(() => {
    if (tokenType === 'to' && fromToken) {
      // Force re-render by updating refreshKey
      setRefreshKey(prev => prev + 1);
      // Close dropdown when fromToken changes to ensure fresh token list
      if (isOpen) {
        setIsOpen(false);
        console.log('🔄 fromToken changed to:', fromToken?.title, '- closing "to" dropdown and forcing refresh');
      }
      console.log('🔄 "To" field - fromToken updated:', fromToken?.title, 'refreshKey:', refreshKey + 1);
    }
  }, [fromToken?.title, tokenType]);
  const defaultTokenFromUrl = searchParams.get('buyToken');
  console.log('defaultReceiveToken in customField', defaultReceiveToken);
  
  const allowedBtcYEmailSet = useMemo(() => {
    if (btcYAllowedEmails instanceof Set) {
      return btcYAllowedEmails;
    }

    if (Array.isArray(btcYAllowedEmails)) {
      return new Set(
        btcYAllowedEmails
          .map((email) => normalizeEmail(email))
          .filter(Boolean)
      );
    }

    return new Set();
  }, [btcYAllowedEmails]);

  const normalizedUserEmail = normalizeEmail(getEmailFromStorage());
  const hasApiAccess = allowedBtcYEmailSet.has(normalizedUserEmail);
  const isSellFlow = type === 'sell';

  // Check if user is whitelisted before allowing BTCY as initial token
  const canUseBTCY = !isSellFlow && hasApiAccess;
  
  // Initialize the token - but prevent BTCY for non-whitelisted users
  let proposedToken = fixedToken || {
    title: defaultReceiveToken?.title || defaultTokenFromUrl || 'INEX',
    image: defaultReceiveToken?.image || defaultTokenFromUrl || 'INEX',
  };

  // If proposed token is BTCY and user is NOT whitelisted, use INEX instead
  if (proposedToken?.title?.toUpperCase() === 'BTCY' && !canUseBTCY) {
    console.log('🚫 Preventing BTCY as initial token for non-whitelisted user. Using INEX instead.');
    proposedToken = { title: 'INEX', image: 'INEX' };
  }
  
  const initialToken = proposedToken;
  const [selectedToken, setSelectedToken] = useState(initialToken);
  console.log('initialToken', initialToken, 'tokenType:', tokenType, 'canUseBTCY:', canUseBTCY);
  const classes = useStyles({
    cryptoSymbol: initialToken.title,
  });
  const location = useLocation();
  const [focused, setFocused] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [userAmount, setUserAmount] = useState(amount);
  const [rateData, setRateData] = useState(0);
  const fixedTokenRef = useRef(fixedToken);
  const theme = useTheme();
  const [refreshKey, setRefreshKey] = useState(0); // Force re-render when fromToken changes
  const [whitelistRefreshKey, setWhitelistRefreshKey] = useState(0); // Force re-render when whitelisted status changes
  const handleFocus = () => {
    setFocused(true);
  };
  const handleBlur = () => {
    setFocused(false);
  };
  const handleOpenModal = () => {
    setIsOpen(true);
  };
  const handleClickAway = () => {
    setIsOpen(false);
  };
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    getPricesData(defaultTokenFromUrl);
  }, [defaultTokenFromUrl]);

  useEffect(() => {
    setUserAmount(amount);
  }, [amount]);

  const handleTokenSelect = (token) => {
    console.log('I am here', token, disableDropdown);
    if (!disableDropdown) {
      getPricesData(token.title);
      setSelectedToken(token);
      onSelectToken(token);

      let basePath = '/update/home';
      if (token.isStock) {
        basePath = '/update/home/stock-token';
      } else if (token.isETF) {
        basePath = '/update/home/etf-tokens';
      }

      // Construct the new URL with the buyToken parameter
      let newUrl = `${basePath}?buyToken=${token.title}`;

      if (token.title === 'IUSD+') {
        const encodedTokenTitle = encodeURIComponent(token.title);

        newUrl = `${basePath}?buyToken=${encodedTokenTitle}`;
      }

      navigate(newUrl);
    }
    setIsOpen(false);
  };

  const handleBeforeInput = (e) => {
    const inputChar = e.data; // The character being inserted
    const currentValue = e.target.value;
    const cursorPosition = e.target.selectionStart;

    // For buy tab: only allow digits
    if (type === 'buy') {
      if (inputChar && !/^\d$/.test(inputChar)) {
        e.preventDefault();
      }
    }
    // For sell tab: allow digits and decimal point (with restrictions)
    else if (type === 'sell') {
      // Allow digits and decimal point
      if (inputChar && !/^[\d.]$/.test(inputChar)) {
        e.preventDefault();
      }
      // Prevent multiple decimal points
      else if (inputChar === '.' && currentValue.includes('.')) {
        e.preventDefault();
      }
      // Prevent more than 2 decimal places (only when inserting AFTER the decimal point)
      else if (currentValue.includes('.') && /^\d$/.test(inputChar)) {
        const decimalIndex = currentValue.indexOf('.');
        const decimalPart = currentValue.split('.')[1];
        // Only prevent if cursor is after the decimal point AND there are already 2 decimal digits
        if (
          cursorPosition > decimalIndex &&
          decimalPart &&
          decimalPart.length >= 2
        ) {
          e.preventDefault();
        }
      }
    }
  };

  const handleAmountChange = async (e) => {
    const amount = e.target.value;

    // For buy tab: only allow whole numbers
    if (type === 'buy') {
      const parsedValue = parseInt(amount, 10);
      // Check if the input contains only digits or is empty
      if (/^\d*$/.test(amount)) {
        if (!isNaN(parsedValue) && parsedValue >= 0) {
          setUserAmount(amount);
          if (onAmountChange) {
            onAmountChange(amount);
          }
        } else if (amount === '') {
          setUserAmount('');
          // Always call onAmountChange when amount is empty
          if (onAmountChange) {
            onAmountChange('');
          }
        }
      }
    }
    // For sell tab: allow decimals with up to 2 decimal places
    else if (type === 'sell') {
      // Allow digits, optional decimal point, and up to 2 decimal places
      if (/^\d*\.?\d{0,2}$/.test(amount)) {
        const parsedValue = parseFloat(amount);
        if (!isNaN(parsedValue) && parsedValue >= 0) {
          setUserAmount(amount);
          if (onAmountChange) {
            onAmountChange(amount);
          }
        } else if (amount === '' || amount === '.') {
          setUserAmount(amount);
          // Always call onAmountChange when amount is empty or just a decimal point
          if (onAmountChange) {
            onAmountChange(amount);
          }
        }
      }
    }
  };

  const calculateReceiveAmount = (amount, rate) => {
    const receiveAmount = type === 'buy' ? amount / rate : amount * rate;
    return receiveAmount.toFixed(2);
  };

  const getPricesData = async (currency) => {
    setTokenPriceLoading(true);
    const res = await getCoinPriceByName(String(currency));
    setTokenPriceLoading(false);
    const priceData = res.data.results.data;
    setRateData(priceData);
    if (onPriceChange) {
      onPriceChange({ priceData, currency });
    }
  };

  useEffect(() => {
    if (userAmount && rateData) {
      const receiveAmount = calculateReceiveAmount(userAmount, rateData);
      if (onReceiveAmountChange) {
        onReceiveAmountChange(receiveAmount);
      }
    }
  }, [userAmount, rateData, onReceiveAmountChange]);

  // Get whitelisted status directly from localStorage for useMemo
  const whitelistedForMemo = useMemo(() => {
    const stored = localStorage.getItem('isWhitelisted');
    return stored !== null && String(stored).toLowerCase() === 'true';
  }, [isWhitelisted, whitelistRefreshKey]); // Recalculate when these change
  
  // Memoize filtered tokens to recalculate when fromToken or isWhitelisted changes
  const filteredTokens = useMemo(() => {
    // Use state variable for whitelisted status (updated via useEffect)
    // Get the latest fromToken value (in case it changed)
    const currentFromToken = fromToken;
    const fromTokenTitle = currentFromToken?.title || currentFromToken?.image || '';
    const fromTokenIsBTCY = fromTokenTitle.toUpperCase() === 'BTCY';
    
    // Also check localStorage directly as a fallback
    // Handle case-insensitive check for 'true' (could be 'True', 'TRUE', etc.)
    const storedValue = localStorage.getItem('isWhitelisted');
    const whitelistedFromStorage = storedValue !== null && String(storedValue).toLowerCase() === 'true';
    // Explicitly check both - user is whitelisted only if either state or storage says true
    const finalIsWhitelisted = isWhitelisted === true || whitelistedFromStorage === true;
    
    // Debug logging for "from" field
    if (tokenType === 'from') {
      console.log('🔍🔍🔍 WHITELIST CHECK (FROM) - storedValue:', storedValue, 'whitelistedFromStorage:', whitelistedFromStorage, 'isWhitelisted (state):', isWhitelisted, 'finalIsWhitelisted:', finalIsWhitelisted);
      console.log('🔍 Will BTCY be shown?', finalIsWhitelisted === true ? 'YES (whitelisted)' : 'NO (not whitelisted - BTCY will be hidden)');
    }
    
    console.log('🔍🔍🔍 filterTokens (useMemo) called - tokenType:', tokenType);
    console.log('🔍 isWhitelisted (state):', isWhitelisted, 'isWhitelisted (storage):', whitelistedFromStorage, 'finalIsWhitelisted:', finalIsWhitelisted);
    console.log('🔍 fromToken title:', fromTokenTitle, 'fromTokenIsBTCY:', fromTokenIsBTCY);
    console.log('🔍 Full fromToken object:', JSON.stringify(currentFromToken));
    
    // Early return validation for "to" field with BTCY
    if (tokenType === 'to') {
      console.log('🚨 "To" field check - finalIsWhitelisted:', finalIsWhitelisted, 'fromTokenIsBTCY:', fromTokenIsBTCY, 'fromToken:', fromTokenTitle);
      if (finalIsWhitelisted && fromTokenIsBTCY) {
        console.log('🚨🚨🚨 CRITICAL: "To" field, whitelisted user, BTCY selected - MUST show only USDT!');
      } else {
        console.log('⚠️ Condition NOT met - finalIsWhitelisted:', finalIsWhitelisted, 'fromTokenIsBTCY:', fromTokenIsBTCY);
      }
    }
    
    // Filter tokens based on tokenType
    // CRITICAL: For "from" field, filter out BTCY immediately if user is not whitelisted
    // Use whitelistedForMemo which is recalculated when whitelisted status changes
    let filtered = tokens.filter((token) => {
      // For "from" field with non-whitelisted users, exclude BTCY immediately - NO EXCEPTIONS
      if (tokenType === 'from') {
        const isBTCY = token.title?.toUpperCase() === 'BTCY';
        // Use whitelistedForMemo for immediate filtering
        if (isBTCY && !whitelistedForMemo) {
          console.log('🚫 IMMEDIATE FILTER: Excluding BTCY from initial filter. whitelistedForMemo:', whitelistedForMemo, 'finalIsWhitelisted:', finalIsWhitelisted);
          return false; // Exclude BTCY immediately for non-whitelisted users
        }
      }
      
      // Handle Convert tab token types ('from' and 'to')
      if (tokenType === 'from' || tokenType === 'to') {
        // For Convert tab, show all tokens by default (will be filtered by whitelist below)
        return token.commonToken || token.isStock || token.isETF;
      } else if (tokenType === 'Tokens') {
        return token.commonToken && !token.isStock && !token.isETF;
      } else if (tokenType === 'Stock Tokens') {
        return token.isStock;
      } else if (tokenType === 'ETF Tokens') {
        return token.isETF;
      }
      return false;
    });

    filtered = filtered.filter(isTokenVisibleOnBuySell);
    console.log('🔍 After initial filtering:', filtered.length, 'tokens. BTCY present:', filtered.some(t => t.title?.toUpperCase() === 'BTCY'));

    if (isSellFlow) {
      const beforeSellFilter = filtered.length;
      filtered = filtered.filter(
        (token) => token.title?.toUpperCase() !== 'BTCY'
      );
      if (beforeSellFilter !== filtered.length) {
        console.log(
          '🔒 Sell tab filter applied - BTCY removed. Before:',
          beforeSellFilter,
          'After:',
          filtered.length
        );
      }
    }

    // Whitelisted user restrictions for Convert tab
    if (tokenType === 'from' || tokenType === 'to') {
      if (tokenType === 'from') {
        // For "from" field:
        // Show BTCY ONLY if user is whitelisted, hide it for non-whitelisted users
        // Use BOTH finalIsWhitelisted AND direct localStorage check for maximum safety
        const directCheck = localStorage.getItem('isWhitelisted');
        const directWhitelisted = directCheck !== null && String(directCheck).toLowerCase() === 'true';
        const userIsWhitelisted = finalIsWhitelisted === true && directWhitelisted === true;
        
        if (userIsWhitelisted) {
          // Whitelisted users: show ALL tokens including BTCY
          console.log('✅ Whitelisted user - Showing ALL tokens including BTCY in "from" tab. Total tokens:', filtered.length);
        } else {
          // Non-whitelisted users: EXCLUDE BTCY completely - NO EXCEPTIONS
          const beforeFilter = filtered.length;
          const btycBefore = filtered.filter(t => t.title?.toUpperCase() === 'BTCY');
          console.log('🔍 Non-whitelisted user - Filtering BTCY from "from" tab. BTCY tokens found:', btycBefore.length, 'finalIsWhitelisted:', finalIsWhitelisted, 'directWhitelisted:', directWhitelisted);
          
          // Remove BTCY - use multiple passes to ensure it's gone
          filtered = filtered.filter((token) => {
            const tokenTitle = token.title?.toUpperCase();
            return tokenTitle !== 'BTCY';
          });
          
          // Second pass - just in case
          filtered = filtered.filter((token) => {
            const tokenTitle = token.title?.toUpperCase();
            const isBTCY = tokenTitle === 'BTCY';
            if (isBTCY) {
              console.error('🚨 BTCY found in second pass! Removing...');
            }
            return !isBTCY;
          });
          
          const btycAfter = filtered.filter(t => t.title?.toUpperCase() === 'BTCY');
          console.log('🔍 Non-whitelisted user - BTCY filtered out from "from" tab. Before:', beforeFilter, 'After:', filtered.length, 'BTCY was present:', btycBefore.length, 'BTCY now present:', btycAfter.length);
          
          // Final verification - if BTCY is still there, something is very wrong
          if (btycAfter.length > 0) {
            console.error('❌❌❌ CRITICAL ERROR: BTCY still present after double filtering!', btycAfter);
            // Force remove one more time
            filtered = filtered.filter(t => {
              const isBTCY = t.title?.toUpperCase() === 'BTCY';
              return !isBTCY;
            });
          }
        }
      } else if (tokenType === 'to') {
        // For "to" field:
        // If whitelisted user selects BTCY in "from", show ONLY USDT
        // Otherwise, show all tokens (but hide BTCY for non-whitelisted users)
        console.log('🔍 "To" field filtering - finalIsWhitelisted:', finalIsWhitelisted, 'fromTokenIsBTCY:', fromTokenIsBTCY, 'fromToken:', fromTokenTitle);
        
        if (finalIsWhitelisted === true && fromTokenIsBTCY === true) {
          // Whitelisted user selected BTCY in "from": show ONLY USDT
          console.log('🚨 Whitelisted user selected BTCY - Showing ONLY USDT in "to" tab');
          filtered = filtered.filter((token) => {
            const tokenTitle = token.title?.toUpperCase();
            return tokenTitle === 'USDT';
          });
          
          // Ensure USDT exists, if not add it
          if (filtered.length === 0) {
            const usdtToken = tokens.find(t => t.title?.toUpperCase() === 'USDT');
            if (usdtToken) {
              console.log('✅ Adding USDT token to list');
              filtered = [usdtToken];
            }
          }
          console.log('✅ "To" field - Only USDT shown. Tokens:', filtered.map(t => t.title).join(', '));
        } else {
          // Normal case: show all tokens, but hide BTCY for non-whitelisted users
          if (finalIsWhitelisted !== true) {
            // Non-whitelisted users: exclude BTCY
            filtered = filtered.filter((token) => {
              return token.title?.toUpperCase() !== 'BTCY';
            });
            console.log('🔍 Non-whitelisted user - BTCY filtered out from "to" tab');
          } else {
            // Whitelisted user with other token selected: show all tokens including BTCY
            console.log('✅ Whitelisted user (other token selected) - showing ALL tokens in "to" tab');
          }
        }
      }
    }

    // FINAL SAFETY CHECK: Ensure BTCY is never shown for users without API access on sell/convert contexts
    if (!hasApiAccess && (tokenType === 'from' || tokenType === 'to')) {
      const beforeFinalCheck = filtered.length;
      const btycCount = filtered.filter(
        (t) => t.title?.toUpperCase() === 'BTCY'
      ).length;
      if (btycCount > 0) {
        console.error(
          '🚨🚨🚨 CRITICAL: BTCY found despite missing API access! Removing it now.'
        );
        filtered = filtered.filter((t) => t.title?.toUpperCase() !== 'BTCY');
        console.log(
          '🚨 Removed',
          btycCount,
          'BTCY token(s) from the list. Before:',
          beforeFinalCheck,
          'After:',
          filtered.length
        );
      }

      const stillHasBTCY = filtered.some(
        (t) => t.title?.toUpperCase() === 'BTCY'
      );
      if (stillHasBTCY) {
        console.error(
          '🚨🚨🚨 ERROR: BTCY still present after final removal! Forcing removal...'
        );
        filtered = filtered.filter((t) => t.title?.toUpperCase() !== 'BTCY');
      }
    }
    
    // Final verification
    const hasBTCY = filtered.some(t => t.title?.toUpperCase() === 'BTCY');
    console.log('🔍 Final filtered tokens for', tokenType, ':', filtered.map(t => t.title).join(', '));
    console.log(
      '🔍 BTCY in final list:',
      hasBTCY,
      'hasApiAccess:',
      hasApiAccess,
      'tokenType:',
      tokenType,
      'type:',
      type
    );
    
    return filtered;
  }, [tokenType, fromToken, isWhitelisted, type, whitelistedForMemo, hasApiAccess]);

  useEffect(() => {
    async function updatedDefaultToken() {
      const path = location.pathname.toLowerCase();
      console.log('path is ', path);

      let defaultToken;

      // Prioritize URL parameter
      if (defaultTokenFromUrl) {
        defaultToken = {
          title: defaultTokenFromUrl,
          image: defaultTokenFromUrl,
        };
      } else if (path === '/update/home') {
        defaultToken = { title: 'INEX', image: 'INEX' };
      } else if (path.includes('etf-tokens')) {
        defaultToken = { title: 'ALCRYP', image: 'ALCRYP' };
      } else if (path.includes('stock-token')) {
        defaultToken = { title: 'AMZN', image: 'AMZN' };
      } else if (defaultReceiveToken) {
        // If defaultReceiveToken is available
        defaultToken = defaultReceiveToken;
      } else {
        // Fallback to a hardcoded default token
        defaultToken = { title: 'INEX', image: 'INEX' };
      }

      // Check if user is whitelisted before allowing BTCY
      const isWhitelistedCheck = localStorage.getItem('isWhitelisted');
      const canUseBTCY =
        !isSellFlow &&
        isWhitelistedCheck !== null &&
        String(isWhitelistedCheck).toLowerCase() === 'true';
      
      // If default token is BTCY and user is NOT whitelisted, use INEX instead
      if (defaultToken?.title?.toUpperCase() === 'BTCY' && !canUseBTCY) {
        console.log('🚫 Preventing BTCY as default token for non-whitelisted user in useEffect. Using INEX instead.');
        defaultToken = { title: 'INEX', image: 'INEX' };
      }

      const finalToken = fixedToken || defaultToken;
      setSelectedToken(finalToken);
      onSelectToken(finalToken); // Call the callback with selected token
    }
    updatedDefaultToken();
  }, [tokenType, defaultReceiveToken, defaultTokenFromUrl, type]);

  const formatBalance = (balance) => {
    if (balance == null || balance === '') return '0';

    const val = Number(balance);
    if (!Number.isFinite(val)) return '0';

    // Prefer higher precision for small/volatile coins
    const highPrecisionCoins = ['BTC', 'BNB', 'ETH', 'LTC'];

    let maxDigits;
    if (val >= 1) {
      // Larger balances: keep it compact
      maxDigits = 2;
    } else if (val >= 0.01) {
      maxDigits = 4;
    } else if (val >= 0.0001) {
      maxDigits = 6;
    } else if (val >= 0.000001) {
      // Extend beyond 6 for small values
      maxDigits = 8;
    } else {
      // Extremely small values: show up to 10 decimals
      maxDigits = 10;
    }

    // For certain coins, allow slightly more precision by default
    if (highPrecisionCoins.includes(selectedToken?.title) && maxDigits < 8) {
      maxDigits = 8;
    }

    return val.toLocaleString(undefined, {
      maximumFractionDigits: maxDigits,
    });
  };
  useEffect(() => {
    console.log(focused, 'focusedValue');
  }, [focused]);

  return (
    <>
      <Box
        className={classes.container}
        sx={{
          border: `1px solid ${
            theme.palette.mode === 'light' ? '#E0E3E7' : '#2D3843'
          }`,
          '&:hover': {
            border: `1px solid ${theme.palette.primary.main} !important`,
          },
          '&:focus-within': {
            border: `1px solid ${theme.palette.primary.main} !important`,
          },
        }}
      >
        <FormControl className={classes.formControl}>
          <InputLabel className={classes.label} shrink htmlFor="input-field">
            {label}
          </InputLabel>
          <TextField
            variant="outlined"
            className={classes.textField}
            placeholder={placeholder}
            type="number"
            value={label === 'Spend' ? userAmount : receiveAmount}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onBeforeInput={handleBeforeInput}
            onChange={handleAmountChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <div
                    className={classes.dropDownIconContainer}
                    style={{ cursor: disableDropdown ? 'default' : 'pointer' }}
                    onClick={disableDropdown ? null : handleOpenModal}
                  >
                    <img
                      src={getImage(selectedToken?.image)}
                      alt={selectedToken?.title}
                    />
                    <p>{selectedToken?.title}</p>
                    {!disableDropdown && <ArrowDropDownIcon />}
                  </div>
                </InputAdornment>
              ),
            }}
            autoComplete="off"
          />
        </FormControl>

        {type === 'sell' && label === 'Spend' && (
          <div className={classes.availableContainer}>
            <Typography
              variant="body2"
              color="textSecondary"
              className={classes.availableText}
            >
              Available:{' '}
              {formatBalance(
                balance
                  ?.filter((wallet) => {
                    const note = wallet.notes ? wallet.notes.toLowerCase() : '';
                    return (
                      wallet.coinSymbol === selectedToken?.image &&
                      (!wallet.notes ||
                        note.includes('gift card') ||
                        note.includes('received from'))
                    );
                  })
                  .reduce((sum, wallet) => sum + wallet.coinBalance, 0)
              )}{' '}
              {selectedToken?.title}
            </Typography>
          </div>
        )}
      </Box>
      <div style={{ position: 'relative', width: '100%' }}>
        {isOpen && !disableDropdown && (
          <ClickAwayListener onClickAway={handleClickAway}>
            <div
              className={classes.dropDownContainer}
              style={{ height: loggedIn ? '342px' : '248px' }}
            >
              <div className={classes.dropDownContent}>
                <div
                  style={{
                    position: '-webkit-sticky',
                    position: 'sticky',
                    top: 0,
                    background:
                      theme.palette.mode === 'dark' ? '#1E2329' : '#ffff',
                    zIndex: '11111',
                    padding: '10px',
                  }}
                >
                  <TextField
                    variant="outlined"
                    className={classes.searchField}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused': {
                          borderColor: `${theme.palette.primary.main} !important`,
                        },
                        '&:hover': {
                          borderColor: `${theme.palette.primary.main} !important`,
                        },
                      },
                    }}
                    placeholder="Search..."
                    value={searchTerm}
                    autoComplete="off"
                    onChange={handleSearchChange}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                <List key={`token-list-${tokenType}-${fromToken?.title || 'none'}-${isWhitelisted}-${refreshKey}-${whitelistRefreshKey}-${localStorage.getItem('isWhitelisted')}`}>
                  {(() => {
                    // Get current whitelisted status directly from localStorage - ALWAYS check fresh
                    const currentWhitelisted = localStorage.getItem('isWhitelisted');
                    const isCurrentlyWhitelisted = currentWhitelisted !== null && String(currentWhitelisted).toLowerCase() === 'true';
                    
                    // Check if BTCY is in filteredTokens
                    const btycInFiltered = filteredTokens.filter(t => t.title?.toUpperCase() === 'BTCY');
                    console.log('🔍 RENDER - tokenType:', tokenType, 'isCurrentlyWhitelisted:', isCurrentlyWhitelisted, 'filteredTokens count:', filteredTokens.length, 'BTCY in filteredTokens:', btycInFiltered.length);
                    
                    // For "from" field with non-whitelisted users, START with a clean list that excludes BTCY
                    let tokensToRender;
                    if (tokenType === 'from' && !isCurrentlyWhitelisted) {
                      // Create a completely fresh array WITHOUT BTCY
                      tokensToRender = [];
                      for (const token of filteredTokens) {
                        const isBTCY = token.title?.toUpperCase() === 'BTCY';
                        if (isBTCY) {
                          console.log('🚫🚫🚫 RENDER: Skipping BTCY token for non-whitelisted user:', token.title);
                          continue; // Skip BTCY completely
                        }
                        
                        // Apply search filter
                        if (token.title.toLowerCase().includes(searchTerm.toLowerCase())) {
                          tokensToRender.push(token);
                        }
                      }
                      console.log('✅ Created fresh list without BTCY. Count:', tokensToRender.length);
                    } else {
                      // Whitelisted user or "to" field - normal filtering
                      tokensToRender = filteredTokens.filter((token) => {
                        return token.title.toLowerCase().includes(searchTerm.toLowerCase());
                      });
                    }
                    
                    // FINAL ABSOLUTE CHECK - if BTCY is still there for non-whitelisted "from" field, remove it
                    if (tokenType === 'from' && !isCurrentlyWhitelisted) {
                      const btycCount = tokensToRender.filter(t => t.title?.toUpperCase() === 'BTCY').length;
                      if (btycCount > 0) {
                        console.error('❌❌❌ ABSOLUTE ERROR: BTCY found in final render list! Count:', btycCount);
                        tokensToRender = tokensToRender.filter(t => t.title?.toUpperCase() !== 'BTCY');
                        console.log('🚨 Removed BTCY. New count:', tokensToRender.length);
                      }
                      
                      // Verify one more time
                      const stillHasBTCY = tokensToRender.some(t => t.title?.toUpperCase() === 'BTCY');
                      if (stillHasBTCY) {
                        console.error('❌❌❌ FATAL: BTCY STILL PRESENT AFTER ALL FILTERS!');
                        // Last resort - filter again
                        tokensToRender = tokensToRender.filter(t => {
                          const isBTCY = t.title?.toUpperCase() === 'BTCY';
                          return !isBTCY;
                        });
                      }
                    }
                    
                    console.log('✅ Final render - tokenType:', tokenType, 'tokens:', tokensToRender.length, 'BTCY present:', tokensToRender.some(t => t.title?.toUpperCase() === 'BTCY'), 'isWhitelisted:', isCurrentlyWhitelisted);
                    
                    return tokensToRender;
                  })()
                    .map((token) => (
                      <ListItem key={token.title} disablePadding>
                        <ListItemButton
                          className={classes.listContainer}
                          onClick={() => handleTokenSelect(token)}
                        >
                          <div className={classes.logoContainer}>
                            <img
                              src={getImage(token.image)}
                              alt={token.title}
                            />
                            <p>{token.title}</p>
                          </div>
                        </ListItemButton>
                      </ListItem>
                    ))}
                </List>
              </div>
            </div>
          </ClickAwayListener>
        )}
        {selectedToken.title === 'WIBS' && type === 'buy' && (
          <img
            src={theme.palette.mode === 'light' ? smbannerlight : smbannerDark}
            style={{
              marginBottom: loggedIn ? '-20px' : '-40px',
              width: '100%',
            }}
          />
        )}
        {selectedToken.title === 'DaCrazy' && type === 'buy' && (
          <img
            src={
              theme.palette.mode === 'dark'
                ? smbannerDaCrazyDarkMode
                : smbannerDaCrazyLightMode
            }
            style={{
              marginBottom: loggedIn ? '-20px' : '-40px',
              width: '100%',
            }}
          />
        )}
      </div>
    </>
  );
};

export default CustomTextField;
